import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  DevNote,
  InfoCardNewAdv,
  InfoText,
  InfoTimeCardAdv,
  KeyValue,
  NewTab,
  PageTab,
  PageTitle,
  Tag,
} from "../../../../../../../components";
import PayStub from "./ProposedEmployees/PayStub";
import Timesheets from "./ProposedEmployees/Timesheets";
import Others from "./ProposedEmployees/Others";
import Expenses from "./ProposedEmployees/Expenses";
import Leaves from "./ProposedEmployees/Leaves";
import AdvancePay from "./ProposedEmployees/AdvancePay";
import Deductions from "./ProposedEmployees/Deductions";
import MiscellaneousPayments from "./ProposedEmployees/MiscellaneousPayments";
import OtherPayment from "./ProposedEmployees/OtherPayment";
import Comments from "./ProposedEmployees/Comments";
import CreditBalance from "./ProposedEmployees/CreditBalance";
import Adjustments from "./ProposedEmployees/Adjustments";
import { dateFormator, getEmployeeId } from "../../../../../../../utils";
import { formatCurrency } from "../../../../../../../utils/stringUtils";
import {
  clearCurrentPayrollEditing,
  setCurrentPayrollEditing,
} from "../../../../../../../redux/slices/payroll/payrollSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import common from "../../../../../../../utils/common";
export const calculateTotalAmount = (data) => {
  const timesheetTotal = data?.totalTimesheetPayAmount || 0;
  const lcaAmount = data?.lcaAmount || 0;
  const difference = data?.difference || 0;
  const otherPaymentAmount = data?.finalOtherTotalAmount || 0;
  const bonusAmount = data?.totalBonuses || 0;
  const shortAdjustments = data?.totalShort || 0;
  const excessAdjustments = data?.totalExcess || 0;
  // return (
  //   timesheetTotal + lcaAmount + otherPaymentAmount + bonusAmount - difference
  // );
  return (
    timesheetTotal +
    otherPaymentAmount +
    bonusAmount -
    difference -
    shortAdjustments +
    excessAdjustments
  );
};
const ProposedEmployeesDetails = ({
  onHoldClick,
  rowData,
  hideButtons = false,
  disableEditing = false,
  tab = null,
}) => {
  const { filterInstallments } = common;
  const dispatch = useDispatch();
  const [totalCal, setTotalCal] = useState(0);
  const { currentPayrollEditing, loading } =
    useSelector((state) => state.payRoll) || {};
  const payroll = currentPayrollEditing;

  useEffect(() => {
    // if (Object.keys(currentPayrollEditing).length > 0) {
    const total = calculateTotalAmount(currentPayrollEditing);
    setTotalCal(total);
    // }
  }, [currentPayrollEditing]);
  useEffect(() => {
    if (rowData) {
      const payrollAmount = Number(rowData?.otherPays?.payrollAmt || 0);
      const additionalPayments = Array.isArray(rowData?.otherPays?.morePay)
        ? rowData?.otherPays?.morePay.reduce(
            (sum, item) => sum + Number(item?.amount || 0),
            0,
          )
        : 0;
      const deductionsHealth = rowData?.deductions?.insurance;
      const clonedDeductionsHealth = deductionsHealth
        ? {
            ...deductionsHealth,
            ids: {
              ...deductionsHealth.ids,
              installments: Array.isArray(deductionsHealth.ids?.installments)
                ? deductionsHealth.ids.installments.filter(
                    (installment) =>
                      Array.isArray(deductionsHealth.installmentId) &&
                      deductionsHealth.installmentId.includes(installment._id),
                  )
                : [],
            },
          }
        : null;
      const regulardeduct =
        rowData?.deductions?.regular?.length > 0
          ? filterInstallments(rowData?.deductions?.regular || [])
          : [];
      const deductions = [];
      // Health Deductions
      if (
        clonedDeductionsHealth &&
        Array.isArray(clonedDeductionsHealth.ids?.installments)
      ) {
        clonedDeductionsHealth.ids.installments.forEach((installment) => {
          deductions.push({
            ...installment,
            id: installment._id,
            deducted: installment.receivable,
            uiid: clonedDeductionsHealth.ids.uiid, // ✅ comes from `ids`
            name: clonedDeductionsHealth.ids.name,
            deductionAmountInput:
              installment.receivableExachange ??
              installment.received ??
              installment.receivable,
            deductionType: clonedDeductionsHealth.ids?.deductionType, // ✅ from `ids`
          });
        });
      }

      // Regular Deductions
      regulardeduct.forEach((data) => {
        const installments = Array.isArray(data.ids?.installments)
          ? data.ids.installments.filter(
              (installment) =>
                Array.isArray(data.installmentId) &&
                data.installmentId.includes(installment._id),
            )
          : [];

        installments.forEach((installment) => {
          deductions.push({
            ...installment,
            id: installment._id,
            deducted: installment.receivable,
            uiid: data.ids.uiid,
            name: data.ids.name,
            deductionAmountLelf:
              installment.receivableExachange ??
              installment.received ??
              installment.receivable,
            deductionType: data.ids?.deductionType,
            metaData:data?.ids
          });
        });
      });
      const filteredDeductions = deductions
      const totalDeductionsAmount = filteredDeductions.reduce(
        (sum, item) => sum + Number(item.deducted || 0),
        0,
      );
      dispatch(
        setCurrentPayrollEditing({
          payrollId: rowData?.uiid,
          employeeName:
            rowData?.employeeId?.firstName && rowData?.employeeId?.lastName
              ? `${rowData?.employeeId?.firstName
                  .charAt(0)
                  .toUpperCase()}${rowData?.employeeId?.firstName.slice(
                  1,
                )} ${rowData?.employeeId?.lastName
                  .charAt(0)
                  .toUpperCase()}${rowData?.employeeId?.lastName.slice(1)}`
              : "-",
          employeeId: rowData?.employeeId,
          employeeIdDisplay:
            getEmployeeId(
              rowData?.employeeId?.uiid,
              rowData?.employeeId?.employmentType,
            ) || "-",
          emailAddress: rowData?.employeeId?.email?.primary || "-",
          phoneNumber:
            rowData?.employeeId?.mobile?.primary?.code &&
            rowData?.employeeId?.mobile?.primary?.number
              ? `${rowData?.employeeId?.mobile?.primary?.code} ${rowData?.employeeId?.mobile?.primary?.number}`
              : "-",
          payCycle:
            rowData?.payCycle?.from && rowData?.payCycle?.to
              ? `${dayjs(rowData?.payCycle?.from)
                  .utc()
                  .format("MM/DD/YYYY")} - ${dayjs(rowData?.payCycle?.to)
                  .utc()
                  .format("MM/DD/YYYY")}`
              : "-",
          creditBalance: "-",
          payDay: dayjs(rowData?.payDay).utc().format("MM/DD/YYYY") ?? "-",
          profile: rowData?.salaryProfileId?.name || "-",

          totalTimesheetHours: rowData?.timesheets?.totalHrs || 0,
          totalTimesheetPayAmount: rowData?.timesheets?.totalPay || 0,

          totalAmount:
            rowData?.amounts?.netPay +
              (rowData?.amounts?.lcaAmt || 0) -
              (rowData?.amounts?.diff || 0) || 0,
          // lcaAmount: rowData?.amounts?.lcaAmt || 0,
          lcaAmount:
            rowData?.payConfigId?.lca?.type === 2
              ? rowData?.payConfigId?.lca?.wages / 12
              : rowData?.payConfigId?.lca?.wages || 0,
          difference: rowData?.amounts?.diff || 0,
          ...(rowData?.otherPays && {
            otherPays: rowData?.otherPays,
            finalOtherTotalAmount: payrollAmount + additionalPayments,
          }),
          deductions:filteredDeductions,
          oldDeductions:deductions,
          totalDeductionsAmount,
          // difference: rowData?.amounts?.diff || 0,
          comments: rowData?.comments,
          totalBonuses: rowData?.bonuses?.totalPay || 0,
          bonusIds: rowData?.bonuses?.ids || [],
          modifications: {
            type: rowData?.timesheets?.modifications?.type || null,
            amt: rowData?.timesheets?.modifications?.amt || null,
          },
          // for adjutsments
          shortDetails: rowData?.adjustments?.short?.ids || [],
          excessDetails: rowData?.adjustments?.excess?.ids || [],
          shortIds: rowData?.adjustments?.short?.ids?.map((a) => a.uiid) || [],
          excessIds:
            rowData?.adjustments?.excess?.ids?.map((a) => a.uiid) || [],
          totalShort: rowData?.adjustments?.short?.amt || 0,
          totalExcess: rowData?.adjustments?.excess?.amt || 0,
        }),
      );
    }
    setTotalCal(formatCurrency(rowData?.amounts?.netPay));
    return () => {
      dispatch(clearCurrentPayrollEditing());
    };
  }, [rowData]);
  const ProposedEmployeeMenus = [
    // { title: "Pay Stub", page: <PayStub onHoldClick={onHoldClick} />, type: "main" },
    {
      title: "Timesheets",

      page: (
        <Timesheets
          rowData={rowData}
          disableEditing={disableEditing}
          tab={tab}
        />
      ),
      type: "main",
    },
    {
      title: "Adjustments",
      page: <Adjustments rowData={rowData} disableEditing={disableEditing} />,
      type: "main",
    },
    // { title: "Others", page: <Others />, type: "main" },
    // { title: "Expenses", page: <Expenses />, type: "main" },
    // { title: "Leaves", page: <Leaves />, type: "main" },
    // { title: "Advance Pay", page: <AdvancePay />, type: "main" },
    {
      title: "Deductions",
      page: (
        <Deductions
          rowData={rowData}
          disableEditing={disableEditing}
          tab={tab}
        />
      ),
      type: "main",
    },
    // {
    //   title: "Miscellaneous Payments",
    //   page: <MiscellaneousPayments />,
    //   type: "main",
    // },
    {
      title: "Other Payment",
      page: <OtherPayment rowData={rowData} disableEditing={disableEditing} />,
      type: "main",
    },
    {
      title: "Payroll Notes",
      page: <Comments rowData={rowData} disableEditing={disableEditing} />,
      type: "main",
    },
    // { title: "Credit Balance", page: <CreditBalance />, type: "main" },
    {
      title: "Pay Stub",
      page: (
        <PayStub
          onHoldClick={onHoldClick}
          rowData={rowData}
          hideButtons={hideButtons}
        />
      ),
      type: "main",
    },
  ];

  return (
    <div>
      <div className="min-h-24 bg-neutrals-50 px-4 py-2">
        <div className="flex flex-col xl:flex-row xl:justify-between gap-5">
          <div className="flex gap-2">
            {/* <DevNote><p>Payroll Id : {payroll?.payrollId}</p></DevNote> */}
            <div className="flex justify-center lg:justify-start items-start">
              <Avatar alt={payroll?.employeeName} size="xxl" src={""} />
            </div>

            <div className="flex flex-col w-full">
              <div className="flex flex-wrap items-center gap-1">
                <h5>{payroll?.employeeName}</h5>
                <Tag
                  title={payroll?.employeeIdDisplay}
                  variant="outlined"
                  color="warning"
                  className="!text-neutrals !py-1"
                />
                <Tag
                  title="Tektree"
                  variant="outlined"
                  color="warning"
                  className="!text-neutrals !py-1"
                />
              </div>

              {/* Info Section */}
              <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                <div className="flex flex-col gap-2">
                  <InfoText
                    icon="email"
                    color=""
                    value={payroll?.emailAddress}
                    oneLine
                    size="sm"
                    // iconColor="primary"
                  />
                  <InfoText
                    icon="phone"
                    color=""
                    value={payroll?.phoneNumber}
                    oneLine
                    size="sm"
                    // iconColor="primary"
                  />
                </div>
                <div className="flex flex-col xl:flex-row xl:items-end gap-2 2xl:gap-5">
                  <div className="flex flex-col gap-2">
                    <InfoText
                      title="Pay Day:"
                      value={payroll?.payDay}
                      oneLine
                      size="sm"
                    />
                    <InfoText
                      title="Profile:"
                      value={payroll?.profile || "-"}
                      oneLine
                      size="sm"
                    />
                  </div>

                  {/* Cycle */}
                  <div className="flex flex-col gap-2">
                    <InfoText
                      title="Pay Cycle:"
                      value={payroll?.payCycle}
                      oneLine
                      size="sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <div className="flex flex-col sm:flex-row xl:flex-col gap-2 items-center xl:items-start">
            {/* <InfoTimeCardAdv
              title=""
              align="center"
              // value={formatCurrency(payroll?.totalAmount || 0)}
              value={formatCurrency(totalCal)}
              variant="contained"
              color="primary"
              size="md"
            /> */}
            <InfoCardNewAdv
              layout="option13"
              title=""
              value={formatCurrency(totalCal)}
              valueConfig={{ className: "text-[28px]! p-1!" }}
            />

            <InfoText
              title="LCA Amount:"
              value={formatCurrency(payroll?.lcaAmount || 0)}
              size="md"
              color=""
              oneLine
            />

            <InfoText
              title={"Difference:"}
              // value={formatCurrency(payroll?.difference || 0)}
              value={formatCurrency(totalCal - payroll?.lcaAmount || 0)}
              size="md"
              color=""
              oneLine
            />
            {/* for close button */}
            {/* <div>
              <Button
              type={"icon"}
              variant="text"
              color="danger"
              icon={"close"}
              size="lg"
              onClick={() => {
                onHoldClick();
              }}
            />
            </div> */}
          </div>
        </div>
      </div>
      <DevNote>
        <div className="w-[300px]">
          {/* <InfoTimeCardAdv
            title="Payroll ID"
            align={"center"}
            // value={formatCurrency(payroll?.totalAmount || 0)}
            value={rowData?.uiid || "Not Found"}
            variant={"contained"}
            color={"primary"}
            size="md"
          /> */}
          <InfoCardNewAdv
            layout="option5"
            title="Payroll ID"
            titleConfig={{ className: "text-[16px]! text-white!" }}
            value={rowData?.uiid || "Not Found"}
            valueConfig={{ className: "text-[28px]! text-white!" }}
            layoutConfig={{ layoutClassName: "gap-3!" }}
            bgConfig={{ className: "bg-primary! rounded-lg!" }}
          />
        </div>
      </DevNote>
      <div className="mt-3">
        <NewTab
          tabs={ProposedEmployeeMenus}
          // tabs={previewMenus}
          color="black"
          // variant="text"
          variant="outlined"
          // activeVariant="text"
        />
      </div>
    </div>
  );
};

export default ProposedEmployeesDetails;
